import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./not-authorized.component.css']
})
export class NotAuthorizedComponent { 
  constructor(private router: Router) {}

  goHome() {
    this.router.navigateByUrl('/');
  }

  goBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.goHome();
    }
  }
}
